// this script was provided by Glove.fit - DO NOT MODIFY
import { jsx as _jsx } from "react/jsx-runtime";
const GLOVE_SCRIPT_V1 = `
  var aid = "3872da8e-3211-11ef-b136-0affd97e338d";
  var url = encodeURIComponent(window.location.href);
  fetch("https://console.glove.fit/api/general/tagurl?aid=" + aid + "&url=" + url)
  .then(response => response.json())
  .then(data => {
      if(data.status === 'ok') {
          const script = document.createElement('script');
          script.async = true;  // This sets the async attribute
          script.src = data.url;
          document.head.appendChild(script);
      }
  })
  .catch(error => console.error('Error fetching the script URL:', error));
`;
const GloveLoader = /*#__PURE__*/ _jsx("script", {
    dangerouslySetInnerHTML: {
        __html: GLOVE_SCRIPT_V1
    }
});
export default GloveLoader;
